export const CREATE_PLAYLIST_REQUEST = "CREATE_PLAYLIST_REQUEST";
export const CREATE_PLAYLIST_SUCCESS = "CREATE_PLAYLIST_SUCCESS";
export const CREATE_PLAYLIST_ERROR = "CREATE_PLAYLIST_ERROR";

export const FETCH_PLAYLISTS_REQUEST = "FETCH_PLAYLISTS_REQUEST";
export const FETCH_PLAYLISTS_ERROR = "FETCH_PLAYLISTS_ERROR";

export const FETCH_PLAYLIST_BY_ID_SUCCESS = "FETCH_PLAYLIST_BY_ID_SUCCESS";
export const FETCH_PLAYLISTS_SUCCESS = "FETCH_PLAYLISTS_SUCCESS";

export const ADD_SONG_TO_PLAYLIST_REQUEST = "ADD_SONG_TO_PLAYLIST_REQUEST";
export const ADD_SONG_TO_PLAYLIST_SUCCESS = "ADD_SONG_TO_PLAYLIST_SUCCESS";
export const ADD_SONG_TO_PLAYLIST_ERROR = "ADD_SONG_TO_PLAYLIST_ERROR";

export const UPDATE_PLAYLIST_REQUEST = "UPDATE_PLAYLIST_REQUEST";
export const UPDATE_PLAYLIST_SUCCESS = "UPDATE_PLAYLIST_SUCCESS";
export const UPDATE_PLAYLIST_ERROR = "UPDATE_PLAYLIST_ERROR";
export const UPDATE_PLAYLIST_RESET = "UPDATE_PLAYLIST_RESET";

export const DELETE_PLAYLIST_REQUEST = "DELETE_PLAYLIST_REQUEST";
export const DELETE_PLAYLIST_SUCCESS = "DELETE_PLAYLIST_SUCCESS";
export const DELETE_PLAYLIST_ERROR = "DELETE_PLAYLIST_ERROR";
export const DELETE_PLAYLIST_RESET = "DELETE_PLAYLIST_RESET";

export const UPDATE_UPDATED_PLAYLIST = "UPDATE_UPDATED_PLAYLIST";
export const ADD_CREATED_PLAYLIST = "ADD_CREATED_PLAYLIST";

export const DELETE_SONG_FROM_PLAYLIST_REQUEST =
  "DELETE_SONG_FROM_PLAYLIST_REQUEST";
export const DELETE_SONG_FROM_PLAYLIST_SUCCESS =
  "DELETE_SONG_FROM_PLAYLIST_SUCCESS";
export const DELETE_SONG_FROM_PLAYLIST_ERROR =
  "DELETE_SONG_FROM_PLAYLIST_ERROR";

export const DELETE_SONG_FROM_ALL_PLAYLISTS_REQUEST =
  "DELETE_SONG_FROM_ALL_PLAYLISTS_REQUEST";
export const DELETE_SONG_FROM_ALL_PLAYLISTS_SUCCESS =
  "DELETE_SONG_FROM_ALL_PLAYLISTS_SUCCESS";
export const DELETE_SONG_FROM_ALL_PLAYLISTS_ERROR =
  "DELETE_SONG_FROM_ALL_PLAYLISTS_ERROR";

export const FETCH_PLAYLIST_SUCCESS = "FETCH_PLAYLIST_SUCCESS";

export const PLAYLIST_TO_UPDATE = "PLAYLIST_TO_UPDATE";
export const PLAYLIST_TO_DELETE = "PLAYLIST_TO_DELETE";

export const playlistTypes = {
  ALL: "ALL",
  OWN: "OWN",
  FOLLOWING: "FOLLOWING",
  RECOMMENDED: "RECOMMENDED",
  LISTENED_RECENTLY: "LISTENED_RECENTLY",
  BASED_ON_LISTENED: "BASED_ON_LISTENED",
  POPULAR: "POPULAR",
};
